import { useMemo } from 'react';

import { HubTooltip } from '@adflow/frontend/ui-common';
import { Checkbox } from '@adflow/frontend/ui-form';

import { useDataTableMeta } from './useDataTableMeta';

interface DataTableSelectorCheckboxProps<T> {
	item: T;
	getId: (item: T) => number | string;
	disabled?: boolean;
	disabledTooltip?: string;
}
export function DataTableSelectorCheckbox<T>(
	props: DataTableSelectorCheckboxProps<T>
) {
	const { item, getId, disabled, disabledTooltip } = props;

	const { selected, setSelected } = useDataTableMeta();
	const itemId = getId(item);

	const checked = useMemo(
		() => selected?.some((id) => String(id) === String(itemId)),
		[itemId, selected]
	);

	const checkbox = (
		<div
			onClick={(e) => {
				if (disabled) {
					e.stopPropagation();
				}
			}}
		>
			<Checkbox
				onChange={() => {
					if (disabled) return;
					if (checked) {
						setSelected((prevSelected) =>
							prevSelected.filter((id) => id !== getId(item))
						);
					} else {
						setSelected((prevSelected) => [...prevSelected, getId(item)]);
					}
				}}
				checked={checked}
				disabled={disabled}
			/>
		</div>
	);

	if (disabled && disabledTooltip) {
		return <HubTooltip title={disabledTooltip}>{checkbox}</HubTooltip>;
	}

	return checkbox;
}
